import React, { useState, useEffect, useRef } from 'react';
import Game from '../../../../class/Game/Game';
import Games from '../../../../class/Game_copy/Game';
import bronzeIcon from '../../static/img/icon-bronze-j.png';
import silverIcon from '../../static/img/icon-silver-j.png';
import goldIcon from '../../static/img/icon-gold-j.png';
import { useTranslation } from 'react-i18next';




const JackPot = ({ AuthService }) => {
  const [jackpots, setJackpots] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const jackpotRef = useRef(null);

  const { t } = useTranslation();

  useEffect(() => {
    const fetchJackpots = async () => {
      setLoading(true);
      try {
        const user_id = AuthService.getCustom('user_id');
        const response = await Games.getJackPot(user_id);
        
        if (response.status === "ok" && response.params) {
          if (Object.keys(response.params).length > 0) {
            let data = response.params;


            // Розподіляємо дані за типами джекпотів
            const bronze = data[1];
            const silver = data[2];
            const gold = data[3];

            setJackpots({ bronze, silver, gold });
          } else {
            setJackpots([]);
          }
          
        } else {
          // setError(t('Failed_to_fetch_jackpots'));
          setJackpots(null);
        }
      } catch (err) {
        setError(t('An_error_occurred_while_fetching_jackpots'));
      } finally {
        setLoading(false);
      }
    };

    fetchJackpots();

    // Оновлення джекпотів після завершення анімації
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            fetchJackpots();
          }
        });
      },
      { threshold: 1.0 }
    );

    if (jackpotRef.current) {
      observer.observe(jackpotRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [AuthService]);

  if (loading) return null;

  const jackpotTypes = jackpots && Object.keys(jackpots).length > 0 ? [
    { type: 'bronze', delay: 0, icon: '/assets/img/icon-bronze-j.png', data: jackpots.bronze },
    { type: 'silver', delay: 0.5, icon: '/assets/img/icon-silver-j.png', data: jackpots.silver },
    { type: 'gold', delay: 1, icon: '/assets/img/icon-gold-j.png', data: jackpots.gold }
  ] : [];

  return (
    <div className="boxer-jackpot">
          {(loading || !jackpots) ? (
              <div className="content-loader-games">
                  <div className="loader-spinner"></div>
                  <p>{t('loading')}</p>
              </div>
          ) : error ? (
              <div className="error">{error}</div>
          ) : (
              jackpotTypes.map(({ type, delay, icon, data }, index) => (
            <div key={index} className="jackpot-container" ref={index === jackpotTypes.length - 1 ? jackpotRef : null}>
              <div className="jackpot-values">
                <div className="jackpot-scroll" style={{ animationDelay: `${delay}s` }}>
                  {[...data, ...data, ...data, ...data].map((jackpot, idx) => (
                    <div key={idx} className={`value_j ${type}_j`}>
                      <span>
                        <img src={icon} alt={`${type} icon`} />
                        {type.charAt(0).toUpperCase() + type.slice(1)} jackpot
                      </span>
                      <strong>{parseFloat(data).toFixed(2)} {AuthService.getCustom('currency')}</strong>
                    </div>
                  ))}
                </div>
              </div>
            </div>
              ))
      )}
    </div>
  );
};

export default JackPot;
